import NavBar from 'components/nav-bar/NavBar';
import BulkUploadProgressDock from 'components/bulk-upload/BulkUploadProgressDock';
import ChatModel from 'pages/chat-model';
import styles from '../../styles/features/app-shell.module.css';

const DesktopLayout = ({ children }) => {
  return (
    <div className={styles.shell}>
      <NavBar />
      <div className={styles.main}>
        <div className={styles.contentWrap}>
          <div className={styles.content}>{children}</div>
        </div>
        <BulkUploadProgressDock />
        <div className={styles.chatAside}>
          <ChatModel />
        </div>
      </div>
    </div>
  );
};

export default DesktopLayout;
